module.exports = __webpack_public_path__ + "img/rentalios.white.loader.2faffe97.gif";